import { useWebSocket } from "nate-react-api-helpers";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { useSyncedRef } from "./SyncedRef";
import { jsx as _jsx } from "react/jsx-runtime";
export const WebSocketContext = /*#__PURE__*/ createContext({ send: msg => { throw new Error("send: invalid context"); }, handle: (key, callback) => { throw new Error("handle: invalid context"); } });
export function useSocketNotifications(key, callback, deps) {
    const { handle } = useContext(WebSocketContext); // eslint-disable-next-line
    const cb = useCallback(callback, deps);
    useEffect(() => { return handle(key, cb); }, [key, cb, handle]);
}
export function WebSocketProvider(props) { const handlers = useRef([]); const ws = useWebSocket("/ws/default", msg => { console.log("WebSocket message", msg); try {
    const obj = JSON.parse(msg);
    if ("key" in obj && "data" in obj) {
        handlers.current.filter(v => v.key === obj.key).map(v => { try {
            v.callback(obj.data);
        }
        catch (e) {
            console.error(e);
        } });
    }
    else {
        console.error("unexpected message format (missing key and data)", obj);
    }
}
catch (e) {
    console.error(e);
} }, [], { onClose(socket, e) { console.log("WebSocket closed", e); }, onOpen(socket, e) { console.log("WebSocket opened", e); } }); const wsRef = useSyncedRef(ws); const ctx = useMemo(() => ({ send: msg => { var _wsRef$current; if (!wsRef.current)
        console.error("missing socket connection"); (_wsRef$current = wsRef.current) === null || _wsRef$current === void 0 ? void 0 : _wsRef$current.send(JSON.stringify(msg)); }, handle: (key, callback) => { handlers.current.push({ key, callback }); console.log("ws handler added:" + key); return () => { console.log("ws handler removed:" + key); handlers.current = handlers.current.filter(x => x.key !== key && x.callback !== callback); }; } }), [wsRef]); return /*#__PURE__*/ _jsx(WebSocketContext.Provider, { value: ctx, children: props.children }); }
